import React, { Component } from 'react'
import SaveSpinner from '../../../components/utils/save-spinner'
import CountDownMessage from '../../../components/utils/count-down-message'

class ResumeOptionsComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      nextSave: 2,
      saving: false,
    }
  }

  componentDidMount = () => (this.refreshTimeID = setInterval(() => this.updateCounterDown(), 1000))

  componentWillUnmount = () => clearInterval(this.refreshTimeID)

  updateCounterDown = () => {
    if (this.props.saving) return

    if (this.state.nextSave > 1) {
      this.setState({ nextSave: this.state.nextSave - 1, saving: false })
    } else {
      this.setState({ nextSave: 10, saving: true })
      this.props.saveResume()
    }
  }

  download = e => {
    if (this.props.saving) e.preventDefault()
  }

  render() {
    return (
      <div style={{ display: 'flex' }}>
        <div className="section-basics-line saving-message" style={{ minWidth: '255px' }}>
          <SaveSpinner saving={this.props.saving} error={this.props.error} />
          <div style={{ width: '10px' }}></div>
          <CountDownMessage
            counter={this.state.nextSave}
            saving={this.props.saving}
            error={this.props.error}
          />
        </div>

        <div className="section-basics-line saving-message"></div>

        <div className="section-basics-line saving-message">
          <div style={{ display: 'flex' }}>
            <a
              className={`resume-download-share-link ${this.props.saving ? 'link-disabled' : ''}`}
              href={`${process.env.REACT_APP_API_SERVE_URL}/${this.props.hash}/download`}
              onClick={this.download}
              style={{
                borderRadius: '4px 0px 0px 4px',
                borderRight: '1px solid rgb(122, 133, 153)',
              }}
            >
              Download
            </a>
            <a
              className="resume-download-share-link"
              href={`${process.env.REACT_APP_API_SERVE_URL}/${this.props.hash}`}
              target="_blank"
              rel="noreferrer"
              style={{
                borderRadius: '0px 4px 4px 0px',
                borderLeft: '1px solid rgb(122, 133, 153)',
              }}
            >
              Preview
            </a>
          </div>
        </div>
      </div>
    )
  }
}

export default ResumeOptionsComponent
